import { Injectable, inject } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { AugmentedModelObject } from "@tylertech/metadata-module";
import { AccountDetailDrilldownViewModel, AccountViewModel, BaseItem, Tuple } from "@tylertech/tyler-api-types";

import
{
    AccountBudgetRecapDialogComponent, AccountBudgetRecapDialogData,
    AccountDetailDialogComponent, AccountDetailDialogData, AccountDetailType,
    JournalEntryReceiptDialogComponent, JournalEntryReceiptDialogData,
    JournalEntryTemplateDialogComponent,
} from "../components";

@Injectable({ providedIn: "root" })
export class GeneralLedgerDialogService
{
    private readonly matDialog = inject(MatDialog);


    private getAccounts(items: Array<BaseItem>): AccountViewModel[]
    {
        const accounts: Map<string, AccountViewModel> = new Map<string, AccountViewModel>();
        for (const item of items)
        {
            if (item.IsDeleted)
            {
                continue;
            }

            for (const distro of item.Distributions)
            {
                if (distro.IsDeleted)
                {
                    continue;
                }

                if (!accounts.has(distro.GlAccount.Number))
                {
                    accounts.set(distro.GlAccount.Number, distro.GlAccount);
                }
            }
        }
        return [...accounts.values()];
    }

    showAccountBudgetRecap(items: Array<BaseItem>, summaryDate: Date | string): Promise<false>
    {
        const accounts = this.getAccounts(items);
        const dialogConfig: MatDialogConfig<AccountBudgetRecapDialogData> = {
            data: {
                accounts,
                summaryDate
            }
        };
        const dialogRef = this.matDialog.open(AccountBudgetRecapDialogComponent, dialogConfig);
        return dialogRef.afterClosed().toPromise();
    }

    showAccountDetail(fetch: AccountDetailDrilldownViewModel, type: AccountDetailType): Promise<void>
    {
        const dialogConfig: MatDialogConfig<AccountDetailDialogData> = {
            data: {
                fetch,
                type
            }
        };
        const dialogRef = this.matDialog.open(AccountDetailDialogComponent, dialogConfig);
        return dialogRef.afterClosed().toPromise();
    }

    showJournalEntryReceiptDialog(journalEntryReceipt: AugmentedModelObject): Promise<AugmentedModelObject>
    {
        const dialogConfig: MatDialogConfig<JournalEntryReceiptDialogData> = {
            data: {
                JEReceipt: journalEntryReceipt
            }
        };
        const dialogRef = this.matDialog.open(JournalEntryReceiptDialogComponent, dialogConfig);
        return dialogRef.afterClosed().toPromise();
    }

    showJournalEntryTemplateDialog(): Promise<Tuple<string, number>>
    {
        const dialogRef = this.matDialog.open(JournalEntryTemplateDialogComponent);
        return dialogRef.afterClosed().toPromise();
    }
}
